export default __webpack_public_path__ + "static/media/228.c82ee9d6.gif";